import avatarModule from '../avatarModule';

function avatarScaling(avatarUrlConstants) {
  'ngInject';

  return {
    restrict: 'A',
    replace: false,
    templateUrl: avatarUrlConstants.templates.avatarScaling
  };
}

avatarModule.directive('avatarScaling', avatarScaling);

export default avatarScaling;
